var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Notification",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Notification_Icon",
    "data-name": "Notification Icon",
    d: "M9,21h6a3,3,0,1,1-6,0ZM1.5,19.5a1.5,1.5,0,0,1,0-3H2.25A6.53,6.53,0,0,0,4.5,12V7.5A7.428,7.428,0,0,1,12,0a7.427,7.427,0,0,1,7.5,7.5V12a6.526,6.526,0,0,0,2.251,4.5H22.5a1.5,1.5,0,0,1,0,3Z",
    transform: "translate(0 4)",
    fill: "#6f11ef",
    opacity: 0.76
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Notification_Badge",
    "data-name": "Notification Badge",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(12)",
    fill: "#f90d0d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotification);
export default __webpack_public_path__ + "static/media/noNotification.89a32d841c15475788ebea65b2482ca9.svg";
export { ForwardRef as ReactComponent };